<template>
  <div class="translator-container">
    <v-toolbar
      flat
      dense
      color="white"
      height="56px"
    >
      <v-btn
        icon
        @click="activeTranslatorId = null"
      >
        <v-icon color="primary">arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-title>{{ translator.name || 'ללא שם' }}</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        small
        @click="openTranslatorPage"
      >
        דף מתורגמן
      </v-btn>
    </v-toolbar>

    <v-divider />

    <v-sheet
      v-if="translator.description"
      class="pa-4"
    >
      <vue-markdown :source="translator.description || 'אין תיאור'"></vue-markdown>
    </v-sheet>

    <v-divider />

    <v-expansion-panel
      class="elevation-0"
      :value="0"
    >
      <v-expansion-panel-content
        v-for="contact in contacts"
        :key="contact._id"
      >
        <template v-slot:header>
          <span class="title">{{ contact.name }} <v-chip
              v-if="contact.callFirst"
              color="orange"
              small
              disabled
              class="white--text"
            >ליצור קשר ראשון</v-chip></span>
        </template>
        <contact
          :contact="contact"
          :parent-resource="$store.state.resources.translator"
          :roles="[]"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

  </div>
</template>

<script>
import Contact from "../../../Contact.vue";
import VueMarkdown from "vue-markdown";

export default {
  computed: {
    translator() {
      return this.$store.getters["entity"]("translators", this.activeTranslatorId) || {};
    },
    activeTranslatorId: {
      get() {
        return this.$store.getters["translators/activeTranslatorsIds"][this.compId];
      },
      set(payload) {
        this.$store.commit("translators/SET_ACTIVE_TRANSLATOR_ID", {
          compId: this.compId,
          payload
        });
      }
    },
    contacts() {
      if (!this.activeTranslatorId) {
        return [];
      }
      let contacts = this.$store.getters["translators/contacts"](this.activeTranslatorId);
      return contacts.sort((a, b) => {
        if (a.callFirst && b.callFirst || !a.callFirst && !b.callFirst) return 0;
        else if (a.callFirst) return -1;
        else if (b.callFirst) return 1;
      });
    }
  },
  methods: {
    openTranslatorPage() {
      this.$router.push(`/translators/${this.activeTranslatorId}`);
    }
  },
  props: ["compId"],
  components: {
    Contact,
    VueMarkdown
  }
};
</script>



// WEBPACK FOOTER //
// src/components/events/modules/Translators/Translator.vue